import { useMemo } from "react";
import { useCurrentUserPermissionList } from "../store/selectors/permissionsSelector";
import { PermissionEntityType } from "../types/permissionType";

export const usePermissionChecker = () => {
  const currentUserPermissions = useCurrentUserPermissionList();

  const permissionMap = useMemo(() => {
    const map = new Map<string, boolean>();
    const allPermissions = new Map<string, number[]>();
    for (const permission of currentUserPermissions) {
      const { entityType, permissionName, targetEntityId } = permission;
      const key = targetEntityId != null
        ? `${entityType}.${permissionName}.${targetEntityId}`
        : `${entityType}.${permissionName}`;
      map.set(key, true);

      const allKey = `${entityType}.${permissionName}`;
      if (!allPermissions.has(allKey)) {
        allPermissions.set(allKey, []);
      }
      if (targetEntityId != null) {
        allPermissions.get(allKey)!.push(targetEntityId);
      }
    }
    return { map, allPermissions };
  }, [currentUserPermissions]);

  const userHasPermission = (
    entityType: PermissionEntityType,
    permissionName: string,
    targetEntityId?: number | null
  ): boolean => {
    const key = targetEntityId != null
      ? `${entityType}.${permissionName}.${targetEntityId}`
      : `${entityType}.${permissionName}`;
    return !!permissionMap.map.get(key);
  };

  const userHasAnyPermission = (
    entityType: PermissionEntityType,
    permissionName: string
  ): boolean => {
    const globalKey = `${entityType}.${permissionName}`;
    return (
      !!permissionMap.map.get(globalKey) ||
      (permissionMap.allPermissions.get(globalKey)?.length ?? 0) > 0
    );
  };

  return { userHasPermission, userHasAnyPermission };
};
